import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { getAppViewUserFirstName } from '../../app/store/appViewSlice';
import { connect } from 'react-redux';
import Content from './view';
import { RootState } from '../../store';
import FeedbackButton from './FeedbackButton';
import ViewBase from 'src/components/ViewBase';

type Props = ReturnType<typeof mapStateToProps>;

const Dashboard: FC<Props> = ({ userFirstName }) => {
  const Title = (
    <Box
      display="flex"
      flexWrap="nowrap"
      whiteSpace="nowrap"
      sx={{ userSelect: 'none' }}
    >
      <Typography sx={{ fontSize: ({ spacing }) => spacing(4.375) }}>
        צהריים טובים
      </Typography>
      <Typography
        fontWeight={700}
        marginInlineStart={1}
        sx={{ fontSize: ({ spacing }) => spacing(4.375) }}
      >{`${userFirstName ?? ''}`}</Typography>
      <Typography
        alignSelf="flex-end"
        fontWeight={700}
        sx={{
          fontSize: ({ spacing }) => spacing(3),
          transform: 'translateY(-3px)',
        }}
      >
        ,
      </Typography>
    </Box>
  );

  return (
    <ViewBase
      Title={Title}
      HeaderContent={<FeedbackButton />}
      styles={{
        container: {
          maxHeight: ({ sizes }) =>
            `calc(100vh - ${sizes.general.topBar.height}px)`,
        },
      }}
    >
      <Content />
    </ViewBase>
  );
};

const mapStateToProps = (state: RootState) => ({
  userFirstName: getAppViewUserFirstName(state),
});

export default connect(mapStateToProps)(Dashboard);
